<form (ngSubmit)="submit()" [formGroup]="permissionForm">
	<div *ngIf="saving">
		<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
			<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
		</div>
	</div>
	<p-stepper [(activeStep)]="activeIndex" *ngIf="!saving">
		<p-stepperPanel>
			<ng-template pTemplate="header">
				<button pButton pRipple type="button" class="bg-transparent h-3rem" (click)="changeActiveTabClick(0)"
					[class]="getColorFirstTab()">
					<div class="flex flex-row align-items-center justify-content-center">
						<i class="pi cm-user text-2xl pr-2"></i>
						<label *ngIf="!onExtendedMobile()" class="font-medium text-lg">{{ 'CUSTOMER' | translate }}</label>
					</div>
				</button>
			</ng-template>

			<ng-template pTemplate="content">
				<p-panel styleClass="p-panel-whitebg" header="{{ 'PERSONAL_DATA' | translate }}">
					<div class="grid pt-3">
						<div class="col-12" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.name, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.name, 'label')">{{ 'CUSTOMER_NAME' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.name, 'borderInput')">
									<input type="text" pInputText [ngClass]="dynamicInputTextWidth()"
										id="permission-dialog-customer-name" formControlName="name" autocomplete="customer-name"
										placeholder="{{ 'CUSTOMER_NAME' | translate }}" maxlength="40" />
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.name)" class="flex align-items-center text-50 pt-1"
								[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
						</div>
						<div class="col-12" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.email, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.email, 'label')">{{ 'EMAIL' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.email, 'borderInput')">
									<input type="email" pInputText [ngClass]="dynamicInputTextWidth()"
										id="permission-dialog-customer-email" formControlName="email" autocomplete="customer-email"
										placeholder="{{ 'EMAIL' | translate }}" maxlength="40" />
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.email)" class="flex align-items-center text-50 pt-1"
								[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}. {{'EMAIL_ADDRESS_INVALID' | translate }}.</small>
						</div>
						<div class="col-12" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.description, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.description, 'label')">{{ 'DESCRIPTION' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.description, 'borderInput')">
									<input type="text" pInputText [ngClass]="dynamicInputTextWidth()"
										id="permission-dialog-customer-description" formControlName="description"
										autocomplete="customer-description" placeholder="{{ 'DESCRIPTION' | translate }}"
										maxlength="40" />
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.description)"
								class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
								translate }}</small>
						</div>
						<div class="col-12" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
								[ngClass]="dynamicInputTextFormat('borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="dynamicInputTextFormat('label')">{{ 'LANGUAGE' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="dynamicInputTextFormat('borderInput')">
									<!-- <p-dropdown [options]="languages" optionLabel="name" [ngClass]="dynamicInputTextWidth()"
										appendTo="body" styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
										id="permission-dialog-language" formControlName="language"
										placeholder="{{ 'LANGUAGE' | translate }}" optionValue="code" dataKey="code">
									</p-dropdown> -->
									<p-dropdown [options]="languages" [ngClass]="dynamicInputTextWidth()"
										appendTo="body" styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
										id="permission-dialog-language" formControlName="language" optionValue="code" dataKey="code"
										placeholder="{{ 'LANGUAGE' | translate }}">
										<ng-template let-selected pTemplate="selectedItem">
											<div class="item flex align-items-center justify-content-center">
												<div class="flex align-items-center">
													<img [src]="getCurrentLanguageFlag(selected.code)" class="w-1_5rem pr-2">
													{{ selected.name | translate }}
												</div>
											</div>
										</ng-template>
										<ng-template let-item pTemplate="item">
											<div class="item flex justify-content-center">
												<img [src]="getCurrentLanguageFlag(item.code)" class="w-1_5rem pr-2">
												<div>{{ item.name | translate }}</div>
											</div>
										</ng-template>
									</p-dropdown>
								</div>
							</div>
						</div>
					</div>
				</p-panel>

				<div class="flex py-3 justify-content-end" [class]="this.screenWidth <= MAX_MD_WIDTH ? '' : 'mt-8'">
					<!-- [disabled]="!canSwitchTab()" -->
					<p-button label="{{ 'NEXT' | translate }}" icon="pi cm-arrow-right" iconPos="right" severity="primary"
						(onClick)="changeActiveTabClick(1)" />
				</div>
			</ng-template>
		</p-stepperPanel>

		<p-stepperPanel>
			<ng-template pTemplate="header">
				<button pButton pRipple type="button" class="bg-transparent h-3rem" (click)="changeActiveTabClick(1)"
					[class]="getColorSecondTab()">
					<div class="flex flex-row align-items-center justify-content-center">
						<i class="pi cm-date-time text-2xl pr-2"></i>
						<label *ngIf="!onExtendedMobile()" class="font-medium text-lg">{{ 'PLAN' | translate }}</label>
					</div>
				</button>
			</ng-template>

			<ng-template pTemplate="content">
				<p-panel styleClass="p-panel-whitebg" header="{{ 'TIMEZONE' | translate }}">
					<div class="grid pt-3">
						<div class="col-12" [ngClass]="customPaddingX()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.timezone, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.timezone, 'label')">{{ 'TIMEZONE' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.timezone, 'borderInput')">
									<p-autoComplete formControlName="timezone" [suggestions]="filteredTimezone"
										[ngClass]="dynamicInputTextWidth()" [styleClass]="dynamicInputTextWidth()"
										inputStyleClass="pl-6 sm:pl-5 border-noround-right" id="schedule-input-timezone"
										(completeMethod)="filterTimezone($event)" [dropdown]="true"
										[panelStyleClass]="dynamicAutocomplete()" [forceSelection]="true">
									</p-autoComplete>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.timezone)" class="flex align-items-center text-50 pt-1"
								[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
						</div>
					</div>
				</p-panel>
				<p-panel styleClass="p-panel-whitebg pt-3" header="{{ 'CHECK_IN' | translate }}">
					<div class="grid pt-3">
						<div [ngClass]="col6Responsive()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.startDate, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.startDate, 'label')">{{ 'START_DATE' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.startDate, 'borderInput')">
									<p-calendar [showIcon]="true" inputId="icon" formControlName="startDate" appendTo="body"
										placeholder="dd/mm/yyyy" [defaultDate]="today" dateFormat="dd/mm/yy"
										[ngClass]="dynamicInputShortTextWidth('inputText')"
										[styleClass]="dynamicInputShortTextWidth('inputText')"
										inputStyleClass="pl-6 sm:pl-5 border-noround-right"
										panelStyleClass="{{ dynamicDatepicker() }}">
									</p-calendar>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.startDate)" class="flex align-items-center text-50 pt-1"
								[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
						</div>
						<div [ngClass]="col6Responsive()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.startTime, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.startTime, 'label')">{{ 'START_TIME' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.startTime, 'borderInput')">
									<p-calendar [showIcon]="true" inputId="icon" formControlName="startTime" appendTo="body"
										timeOnly="true" [ngClass]="dynamicInputShortTextWidth('inputText')"
										[styleClass]="dynamicInputShortTextWidth('inputText')"
										inputStyleClass="pl-6 sm:pl-5 border-noround-right">
									</p-calendar>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.startTime)" class="flex align-items-center text-50 pt-1"
								[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
						</div>
					</div>
				</p-panel>
				<p-panel styleClass="p-panel-whitebg pt-3" header="{{ 'CHECK_OUT' | translate }}">
					<div class="grid pt-3">
						<div [ngClass]="col6Responsive()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.endDate, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.endDate, 'label')">{{ 'END_DATE' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.endDate, 'borderInput')">
									<p-calendar [showIcon]="true" inputId="icon" formControlName="endDate" appendTo="body"
										placeholder="dd/mm/yyyy" [minDate]="minDate" [defaultDate]="today" dateFormat="dd/mm/yy"
										[ngClass]="dynamicInputShortTextWidth('inputText')"
										[styleClass]="dynamicInputShortTextWidth('inputText')"
										inputStyleClass="pl-6 sm:pl-5 border-noround-right"
										panelStyleClass="{{ dynamicDatepicker() }}">
									</p-calendar>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.endDate)" class="flex align-items-center text-50 pt-1"
								[ngClass]="justifyContentStyle()">{{ 'PERMISSIONS_DATE_WARNING_INVALID' | translate }}</small>
						</div>
						<div [ngClass]="col6Responsive()">
							<div class="flex justify-content-between flex-wrap"
								[ngClass]="newShowErrors(this.f.endTime, 'borderRow')">
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.endTime, 'label')">{{ 'END_TIME' | translate }}</div>
								<div class="flex align-items-center justify-content-center"
									[ngClass]="newShowErrors(this.f.endTime, 'borderInput')">
									<p-calendar [showIcon]="true" inputId="icon" formControlName="endTime" appendTo="body"
										timeOnly="true" [ngClass]="dynamicInputShortTextWidth('inputText')"
										[styleClass]="dynamicInputShortTextWidth('inputText')"
										inputStyleClass="pl-6 sm:pl-5 border-noround-right">
									</p-calendar>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.endTime)" class="flex align-items-center text-50 pt-1"
								[ngClass]="justifyContentStyle()">{{ 'PERMISSIONS_DATE_WARNING_INVALID' | translate }}</small>
						</div>
					</div>
				</p-panel>
				<div class="flex py-3 justify-content-between">
					<p-button label="{{ 'BACK' | translate }}" icon="pi cm-arrow-left" iconPos="left" severity="secondary"
						(onClick)="changeActiveTabClick(0)" />
					<p-button label="{{ 'NEXT' | translate }}" icon="pi cm-arrow-right" iconPos="right" severity="primary"
						(onClick)="changeActiveTabClick(2)" />
				</div>
			</ng-template>
		</p-stepperPanel>

		<p-stepperPanel>
			<ng-template pTemplate="header">
				<button pButton pRipple type="button" class="bg-transparent h-3rem" (click)="changeActiveTabClick(2)"
					[class]="getColorThirdTab()">
					<div class="flex flex-row align-items-center justify-content-center">
						<i class="pi cm-configuration text-2xl pr-2"></i>
						<label *ngIf="!onExtendedMobile()" class="font-medium text-lg">{{ 'COMMANDS' | translate }}</label>
					</div>
				</button>
			</ng-template>

			<ng-template pTemplate="content">
				<div class="grid">
					<!-------  GENERAL SETTING ------->
					<div class="col-12 pt-0">
						<p-panel styleClass="p-panel-whitebg pt-3">
							<ng-template pTemplate="header">
								<div class="font-semibold">{{ 'GENERIC_SETTINGS' | translate }}</div>
								<!-- <i class="pi cm-configuration ml-2"></i> -->
							</ng-template>
							<!-- Set commands -->
							<div class="col-12">
								<div class="flex justify-content-between flex-wrap"
									[ngClass]="newShowErrors(this.f.selCommands,'borderRow')">
									<div class="flex align-items-center justify-content-center"
										[ngClass]="newShowErrors(this.f.selCommands,'label')">{{ 'COMMANDS' | translate }}</div>
									<div class="flex align-items-center justify-content-center"
										[ngClass]="newShowErrors(this.f.selCommands,'borderInput')">
										<p-multiSelect formControlName="selCommands" [options]="groupedCommands" [group]="true"
											[showToggleAll]="false" appendTo="body" optionLabel="CommandDescription"
											[ngClass]="dynamicInputTextWidth()" optionDisabled="Inactive"
											[styleClass]="dynamicInputTextWidth()" (onChange)="disableListCommand()"
											selectedItemsLabel="{{'SELECTED_ITEM' | translate }}{0}">
											<ng-template let-group pTemplate="group">
												<div class="flex align-items-center">
													<span>{{ group.DeviceName }}</span>
												</div>
											</ng-template>
											<ng-template let-commands pTemplate="selectedItems">
												<span *ngFor="let command of commands;">
													<span class="font-medium text-0">{{ command.CommandDescription }}, </span>
												</span>
											</ng-template>
										</p-multiSelect>
									</div>
								</div>
								<small *ngIf="showErrorRequiredMessage(this.f.selCommands)"
									class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' |
									translate }}</small>
							</div>
							<!-- Set send flags email and access mail -->
							<div class="col-12">
								<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
									[ngClass]="dynamicInputTextFormat('borderRow')">
									<div class="flex align-items-center justify-content-center pb-1"
										[ngClass]="dynamicInputTextFormat('label')">{{ 'SETTINGS_MAIL' | translate }}
									</div>
									<div class="flex align-items-center justify-content-center"
										[ngClass]="dynamicInputTextFormat('borderInput')">
										<p-checkbox formControlName="sendMail" [binary]="true" (onChange)="setAccessMailValue($event)"
											label="{{ 'SEND_MAIL' | translate }}" class="ml-4 mb-2 md:mb-0">
										</p-checkbox>
										<p-checkbox formControlName="sendAccessMail" [binary]="true"
											label="{{ 'SEND_ACCESS_MAIL' | translate }}" class="ml-4 mb-2 md:mb-0">
										</p-checkbox>
									</div>
								</div>
							</div>
						</p-panel>
					</div>
					<!-- PINCODE DEVICES -->
					<div class="col-12 pt-0">
						<p-panel styleClass="p-panel-whitebg">
							<ng-template pTemplate="header">
								<div class="font-semibold">{{ 'CODE_PIN' | translate }}</div>
								<i class="pi cm-keypad ml-2"></i>
							</ng-template>
							<div class="grid p-3 pb-0">
								<!-- EnablePincode flag (is not sended to payload) -->
								<!-- <div [class]="col6ResponsiveNoPadding()">
									<div class="flex justify-content-between flex-wrap border-bottom-1 border-100 pt-2"
										[ngClass]="dynamicInputTextFormat('borderRow')">
										<div class="flex align-items-center justify-content-center"
											[ngClass]="dynamicInputTextFormat('label')">{{ 'SETTINGS_QUICK&EASY_KEYBOARD' | translate }}
										</div>
										<div class="flex align-items-center justify-content-center"
											[ngClass]="dynamicInputTextFormat('borderInput')">
											<p-inputSwitch inputId="permission-enablePincodeDevices-switch" formControlName="enablePincodeDevices" (onChange)="onSelectedEnablePincodeToDevice()"></p-inputSwitch>
										</div>
									</div>
								</div> -->
								<!-- Set send flags pincode to devices -->
								<!-- <div [class]="col6ResponsiveNoPadding()"> -->
								<div *ngIf="isSelectedMtma() || isSelectedRbe()" class="col-12">
									<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
										[ngClass]="dynamicInputTextFormat('borderRow')">
										<div class="flex align-items-center justify-content-center gap-2" [class]="isSelectedMtma() ? '' : 'pb-1'"
											[ngClass]="dynamicInputTextFormat('label')">{{ 'SETTINGS_QUICK&EASY_KEYBOARD' | translate }}
											<i class="pi cm-keypad"></i>
											<p-button *ngIf="isSelectedMtma()"
												pTooltip="{{'NOTE_QE_MIN_FW_VER_MTM_KEYPADS' | translate }}" tooltipPosition="bottom" icon="pi cm-alert"
												size="large" [rounded]="false" [text]="true"
												severity="primary">
											</p-button>
										</div>
										<div class="flex align-items-end justify-content-center"
											[ngClass]="dynamicInputTextFormat('borderInput')">
											<p-checkbox *ngIf="isSelectedRbe()" formControlName="sendPincodeRbe" [binary]="true"
												label="{{ 'SEND_TO_RBE' | translate }}" class="ml-4">
											</p-checkbox>
											<p-checkbox *ngIf="isSelectedMtma()" formControlName="sendPincodeMtma" [binary]="true"
												label="{{ 'SEND_TO_MTMA' | translate }}" class="ml-4">
											</p-checkbox>
										</div>
									</div>
								</div>
								<!-- Set RandomPincode flag -->
								<div class="col-12">
									<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
										[ngClass]="dynamicInputTextFormat('borderRow')">
										<div class="flex align-items-center justify-content-center gap-2"
											[ngClass]="dynamicInputTextFormat('label')">{{ 'GENERATE_RANDOM_CODE' | translate }}
											<p-button
												pTooltip="{{'PINCODE_INFO_TOOLTIP' | translate }}" tooltipPosition="bottom" icon="pi cm-info"
												size="large" [rounded]="false" [text]="true"
												severity="primary">
											</p-button>
										</div>
										<div class="flex align-items-center justify-content-center"
											[ngClass]="dynamicInputTextFormat('borderInput')">
											<p-inputSwitch inputId="permission-pincoderandom-switch" formControlName="pincodeRandom" (onChange)="onSelectedPincodeRandom()"></p-inputSwitch>
										</div>
									</div>
								</div>
								<!-- -----  Pincode--------  -->
								<div class="col-12" *ngIf="!permissionForm.get('pincodeRandom')?.value">
									<div class="flex justify-content-between flex-wrap"
										[ngClass]="newShowErrors(this.f.pincode, 'borderRow')">
										<div class="flex align-items-center justify-content-center"
											[ngClass]="newShowErrors(this.f.pincode, 'label')">{{ 'CODE_PIN' | translate }}
										</div>
										<div class="flex align-items-center justify-content-center"
											[ngClass]="newShowErrors(this.f.pincode, 'borderInput')">
											<input type="text" pInputText [ngClass]="dynamicInputTextWidth()"
												id="permission-dialog-customer-name" formControlName="pincode" autocomplete="customer-name" minlength="5" maxlength="5"
												placeholder="{{'MANUAL_ADD' | translate}}"/>
										</div>
									</div>
									<small *ngIf="showErrorRequiredMessage(this.f.pincode)" class="flex align-items-center text-50 pt-1"
										[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}. {{ 'ERROR_MESSAGE_VALIDATOR_PINCODE' | translate }}</small>
								</div>
							</div>
						</p-panel>
					</div>
					<!--  TAGCODE DEVICES --->
					<div *ngIf="isSelectedMtma() || isSelectedRbe()" class="col-12 pt-0">
						<p-panel styleClass="p-panel-whitebg">
							<ng-template pTemplate="header">
								<div class="font-semibold">{{ 'SINGLE_RFID_CARD' | translate }}</div>
								<i class="pi cm-card ml-2"></i>
							</ng-template>
							<div class="grid p-3 pb-0">
								<!-- EnableRfid flag (is not sended to payload) -->
								<div class="col-12">
									<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
										[ngClass]="dynamicInputTextFormat('borderRow')">
										<div class="flex align-items-center justify-content-center gap-2"
											[ngClass]="dynamicInputTextFormat('label')">{{ 'SETTINGS_QUICK&EASY_TRASPONDER' | translate }}
											<i class="pi cm-card"></i>
											<p-button *ngIf="isSelectedMtma()"
												pTooltip="{{'NOTE_QE_MIN_FW_VER_MTM_TAGS' | translate }}" tooltipPosition="bottom" icon="pi cm-alert"
												size="large" [rounded]="false" [text]="true" severity="primary">
											</p-button>
										</div>
										<div class="flex align-items-center justify-content-center"
											[ngClass]="dynamicInputTextFormat('borderInput')">
											<p-inputSwitch inputId="permission-enableRfid-switch" formControlName="enableRfid" (onChange)="onSelectedEnableTagcodeToDevice()"></p-inputSwitch>
										</div>
									</div>
								</div>
							</div>
							<div class="grid p-3">
								<!-- Rfid Tagcode -->
								<div [class]="col6ResponsiveNoPadding()" *ngIf="permissionForm.get('enableRfid')?.value">
									<div class="flex justify-content-between flex-wrap w-full"
										[ngClass]="newShowErrors(this.f.rfid, 'borderRow')">
										<div class="flex align-items-center justify-content-center"
											[ngClass]="newShowErrors(this.f.rfid, 'label')">{{ 'RFID_CARD_CODE' | translate }}
										</div>
										<div class="flex align-items-center justify-content-center"
											[ngClass]="newShowErrors(this.f.rfid, 'borderInput')">
											<input type="text" pInputText [ngClass]="dynamicInputShortTextWidth()"
												id="permission-dialog-rfid-code" formControlName="rfid" maxlength="12"
												placeholder="{{ 'MANUAL_ADD' | translate }}"/>
										</div>
									</div>
									<small *ngIf="showErrorRequiredMessage(this.f.rfid)" class="text-50 pt-1"
										[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
								</div>
								<!-- Set send flags tagcode to devices -->
								<div [class]="col6ResponsiveNoPadding()" *ngIf="permissionForm.get('enableRfid')?.value">
									<div class="flex justify-content-between flex-wrap border-bottom-1 border-100 pt-1"
										[ngClass]="dynamicInputTextFormat('borderRow')">
										<div class="flex justify-content-center pb-1"
											[ngClass]="dynamicInputTextFormat('label')">{{ 'SEND_TO_DEVICES' | translate }}
										</div>
										<div class="flex justify-content-center"
											[ngClass]="dynamicInputTextFormat('borderInput')">
											<p-checkbox *ngIf="isSelectedRbe()" formControlName="sendTrasponderRbe" [binary]="true"
												label="{{ 'SEND_TO_RBE' | translate }}" class="ml-4">
											</p-checkbox>
											<p-checkbox *ngIf="isSelectedMtma()" formControlName="sendTrasponderMtma" [binary]="true"
												label="{{ 'SEND_TO_MTMA' | translate }}" class="ml-4">
											</p-checkbox>
										</div>
									</div>
								</div>
							</div>
						</p-panel>
					</div>
				</div>
				<div class="flex justify-content-start">
					<p-button label="{{ 'BACK' | translate }}" icon="pi cm-arrow-left" severity="secondary"
						(onClick)="changeActiveTabClick(1)" />
				</div>
			</ng-template>
		</p-stepperPanel>

		<ng-template pTemplate="end">
			<div class="grid mt-2 mx-1 flex justify-content-center align-items-center" *ngIf="!saving">
				<button *ngIf="enableConfirmButtons()" type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
					class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
				</button>
				<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
					class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
				</button>
			</div>
		</ng-template>

	</p-stepper>
</form>